/**
 * Performance Monitor Utility
 * Tracks Web Vitals and other performance metrics
 */

import { isDevelopmentMode } from './env';

export interface PerformanceMetrics {
  fcp: number | null;
  lcp: number | null;
  cls: number | null;
  fid: number | null;
  ttfb: number | null;
}

const metrics: PerformanceMetrics = {
  fcp: null,
  lcp: null,
  cls: null,
  fid: null,
  ttfb: null,
};

export function initPerformanceMonitoring() {
  if (typeof window === 'undefined') return;

  // TTFB
  const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
  if (navigation) {
    metrics.ttfb = navigation.responseStart - navigation.startTime;
  }

  // FCP
  new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries()) {
      if (entry.name === 'first-contentful-paint') {
        metrics.fcp = entry.startTime;
      }
    }
  }).observe({ type: 'paint', buffered: true });

  // LCP
  new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];
    metrics.lcp = lastEntry.startTime;
  }).observe({ type: 'largest-contentful-paint', buffered: true });

  // CLS
  let clsValue = 0;
  new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries() as unknown[]) {
      const entryObj = entry as Record<string, unknown>;
      if (!entryObj.hadRecentInput) {
        clsValue += (entryObj.value as number);
        metrics.cls = clsValue;
      }
    }
  }).observe({ type: 'layout-shift', buffered: true });

  // FID
  new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries() as unknown[]) {
      const entryObj = entry as Record<string, unknown>;
      metrics.fid = (entryObj.processingStart as number) - (entryObj.startTime as number);
    }
  }).observe({ type: 'first-input', buffered: true });

  // Log metrics in development
  if (isDevelopmentMode()) {
    setInterval(() => {
      console.log('[Performance Metrics]', metrics);
    }, 10000);
  }
}

export function getPerformanceMetrics(): PerformanceMetrics {
  return { ...metrics };
}
